var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Comments",
    clipPath: "url(#clip0_2503_3663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.00974 0C5.15577 0 3.37796 0.737565 2.06722 2.05062C0.755899 3.36302 0.0193108 5.14327 0.0193108 6.99969C0.0134129 8.61592 0.572415 10.1836 1.59932 11.4304L0.201503 12.83C0.00293703 13.0315 -0.0547237 13.3327 0.0547092 13.5932C0.173324 13.8511 0.435451 14.0112 0.718555 13.9994H7.00974C9.50725 13.9994 11.8147 12.6653 13.0637 10.4992C14.3121 8.33368 14.3121 5.66571 13.0637 3.50018C11.8146 1.33399 9.50725 0 7.00974 0ZM7.00974 12.599H2.40342L3.0535 11.9481C3.32416 11.6751 3.32416 11.2341 3.0535 10.9612C1.82345 9.73145 1.23493 7.99838 1.46039 6.27197C1.68649 4.54624 2.70093 3.0231 4.2062 2.15242C5.7115 1.28099 7.53533 1.15958 9.14218 1.82498C10.7484 2.49036 11.9549 3.86569 12.4057 5.54691C12.8572 7.22745 12.5014 9.0234 11.4443 10.4054C10.3873 11.7874 8.74835 12.5978 7.00963 12.5992L7.00974 12.599Z",
    fill: "#0A0A0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2503_3663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.37b0e9909cc7d53fd6b8e35bda1f6912.svg";
export { ForwardRef as ReactComponent };